/**
 * Token Storage Module
 * Handles JWT token and user data persistence in localStorage
 */

import type { User } from "./types";

const TOKEN_STORAGE_KEY = "magiclinks_api_token";
const USER_STORAGE_KEY = "magiclinks_api_user";

export const tokenStorage = {
  getToken: (): string | null => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  },

  setToken: (token: string): void => {
    if (typeof window === "undefined") return;
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  },

  removeToken: (): void => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  },

  getUser: (): User | null => {
    if (typeof window === "undefined") return null;
    const userJson = localStorage.getItem(USER_STORAGE_KEY);
    if (!userJson) return null;
    try {
      return JSON.parse(userJson) as User;
    } catch {
      return null;
    }
  },

  setUser: (user: User): void => {
    if (typeof window === "undefined") return;
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  },

  removeUser: (): void => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(USER_STORAGE_KEY);
  },

  clearAuth: (): void => {
    tokenStorage.removeToken();
    tokenStorage.removeUser();
  },

  isAuthenticated: (): boolean => {
    return !!tokenStorage.getToken();
  },
};
